<template lang="pug">
  .FileUploader
    .FileUploader-status.Status(
      v-if="file && file.name",
      :class="{'Status--error': file && file.errors && file.errors.length > 0, 'Status--progress': uploadProgress > 0 && uploadProgress < 100}")
      .Status-icon
        i.Icon.IconDocument2
      .Status-info
        .Status-main
          .Status-name.OneLine {{file.name}}
          .Status-remove(v-if="!(file.errors && file.errors[0] && file.errors[0] === 'uploadingError')")
            button.Btn.BtnIcon(@click="removeFile")
              i.Icon.IconClose
        .Status-progress(v-if="uploadProgress > 0 && uploadProgress < 100")
          .Status-uploaded(:style="{'width': uploadProgress + '%'}")
        .Status-error(v-if="file.errors")
          span(v-if="file.errors[0] && file.errors[0] === 'type'") Некорректный формат файла
          span(v-if="file.errors[0] && file.errors[0] === 'uploadingError'") Ошибка загрузки
      .Status-remove(v-if="file.errors && file.errors[0] && file.errors[0] === 'uploadingError'")
        button.Btn.Btn--light Повторить загрузку
        button.Btn.BtnIcon
          i.Icon.IconClose
    .FileUploader-box(
      :class="{'FileUploader-box--dragover': isOver}",
      @dragover="dragoverprevent",
      @dragleave="isOver = false",
      @drop.prevent="addFile($event)"
    )
      input#fileUploader.FileUploader-input(type="file", ref="file", @input="changeFile")
      label(for="fileUploader")
        .FileUploader-icon
          i.Icon.IconSaveAsPng
        b Перетащите файл для загрузки
        span или
        button.Btn.Btn--blue.Btn--light Выберите файл
    .FileUploader-types Формат: {{types.join(', ')}}
</template>

<script>
  export default {
    name: 'FileUpload',
    data() {
      return {
        file: null,
        isOver: false,
      }
    },
    props: {
      uploadProgress: {
        type: Number,
        default: 0
      },
      initialFile: {
        type: Object,
        default: () => {}
      },
      types: {
        type: Array,
        default: () => {return []}
      }
    },
    watch: {
      initialFile(newVal) {
        this.file = this.formatFileObject(this.initialFile)
      }
    },
    mounted() {
      if(this.initialFile) {
        this.file = this.formatFileObject(this.initialFile)
      }
    },
    methods: {
      dragoverprevent(e) {
        this.isOver = true
        e.preventDefault()
      },
      addFile(e) {
        this.isOver = false
        let droppedFiles = e.dataTransfer.files
        if(!droppedFiles || droppedFiles.length === 0) return
        this.changeFile({target: {files: droppedFiles}})
      },
      removeFile() {
        this.file=null
        this.$emit('changeFile', this.file)
      },
      changeFile(e) {
        this.file = {
          name: e.target.files[0] ? e.target.files[0].name : '',
          file: e.target.files[0]
        }
        if(e.target.files[0] && this.validateFile(e.target.files[0])) {
          this.$emit('changeFile', this.file)
        }
      },
      validateFile(file) {
        this.file.errors = []
        const parts = file.name.split('.')
        const type = parts.length > 0 ? parts[parts.length - 1] : ''
        if(this.types.indexOf(type) === -1) {
          this.file.errors.push('type')
        }
        return !this.file.errors.length
      },
      formatFileObject(file) {
        if(file && file.url) {
          file.name = ''
          file.path = ''
          const parts = file.url.split('/')
          file.name = parts[parts.length - 1]
          parts.splice(-1,1)
          file.path = parts.join('/')
        }
        return file
      },
    }
  }
</script>
<style lang="scss">
  @import "~base";

  .Popup .FileUploader,
  #app .FileUploader {
    --borderColor: #{$grey3};
    --boxBg: #{$white};
    --boxOverBg: #{$grey6};
    --accentColor: #{$blue};
    --errorColor: #{$red};
    --boldLabel: #{$black5};
  }

  .Popup[data-theme='dark'] .FileUploader,
  #app[data-theme='dark'] .FileUploader{
    --borderColor: #{$grey2};
    --boxBg: transparent;
    --boxOverBg: #{$black4};
    --accentColor: #{$blue};
    --errorColor: #{$red};
    --boldLabel: #{$white3};
  }
</style>
<style scoped lang="scss">
  @import '~base';

  .FileUploader {
    &-types {
      margin-top: 5px;
      color: var(--secondaryText);
      font-size: 12px;
    }

    &-box {
      height: 183px;
      border: 1px dashed var(--borderColor);
      background: var(--boxBg);
      border-radius: 8px;
      text-align: center;

      input {
        display: none;
      }

      label {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
      }

      &--dragover {
        border: 1px dashed var(--accentColor);
        background: var(--boxOverBg);
      }

      label {
        b, span, button {
          display: inline-block;
          margin-top: 8px;
          line-height: 16px;
        }

        b {
          font-size: 14px;
          font-weight: 500;
          color: var(--boldLabel);
        }

        span {
          margin-top: 5px;
          color: var(--secondaryText);
          font-size: 12px;
        }

        button {
          width: 155px;
          pointer-events: none;
        }
      }
    }

    &-status {
      margin-bottom: 24px;
    }

    &-icon {
      width: 43px;
      height: 43px;
      border: 1px solid var(--borderColor);
      background: var(--boxBg);
      border-radius: 8px;
      line-height: 39px;

      .Icon {
        color: var(--accentColor);
      }
    }
  }

  .Status {
    display: flex;
    align-items: center;

    &-icon {
      flex: 0 0 30px;
      color: var(--accentColor);

      .Icon {
        font-size: 20px;
      }
    }

    &-info {
      flex: 1 1 0;
      overflow: hidden;
    }

    &-name {
      font-size: 14px;
      line-height: 16px;
      flex: 1 1 auto;
    }

    &-main {
      display: flex;
      align-items: center;
    }

    &-main &-remove {
      flex: 0 0 40px;
      text-align: right;

      button {
        height: 21px;
      }
    }

    &-progress {
      position: relative;
      height: 4px;
      width: 100%;
      border: 1px solid var(--borderColor);
      border-radius: 4px;
    }

    &-uploaded {
      position: absolute;
      height: 4px;
      top: -1px;
      border-radius: 4px;
      background: var(--accentColor);
    }

    &-remove {
      button {
        margin-left: 15px;

        &.Btn--light {
          padding: 0;
          background: transparent;
          color: var(--accentColor);
        }
      }

      .Icon {
        color: var(--secondaryText);
        font-size: 10px;
      }
    }

    &-error {
      color: var(--errorColor);
      font-size: 12px;
      line-height: 12px;
    }

    &--error &-icon {
      color: var(--errorColor);
    }

    &--progress &-icon,
    &--progress &-name {
      color: var(--secondaryText)
    }



  }
</style>



// WEBPACK FOOTER //
// src/components/FileUpload.vue